import { FC } from "react";

const InputSelectSeparator: FC = () => <option disabled>──────────</option>;

export default InputSelectSeparator;
